import { defineStore } from 'pinia'
import { useRouter } from "vue-router";
const router = useRouter();

export interface TagItem {
  unique_id: string
  type: string
  desc: string
  max_length: number
  min_length: number
  imgae_type: string
  demo_value: string
  remarks: string
}

export interface CanvasTagGroup {
  id: string
  taglist: TagItem[]
}

export interface TagListState {
  tagListGroup: CanvasTagGroup[]
}

const STORAGE_KEY = 'tagListGroup'

export const useTagListStore = defineStore('tagList', {
  state: (): TagListState => ({
    tagListGroup: []
  }),

  getters: {
    allTagGroups(state): CanvasTagGroup[] {
      return state.tagListGroup
    },
    getTagListByCanvasId: (state) => (canvasId: string): TagItem[] => {
      const group = state.tagListGroup.find(item => item.id === canvasId)
      return group ? group.taglist : []
    },
    getTagDetail: (state) => (canvasId: string, unique_id: string): TagItem | undefined => {
      const group = state.tagListGroup.find(item => item.id === canvasId)
      if (group) {
        return group.taglist.find(tag => tag.unique_id === unique_id)
      }
      return undefined
    }
  },

  actions: {
    // saveToStorage() {
    //   localStorage.setItem(STORAGE_KEY, JSON.stringify(this.tagListGroup))
    // },
    addTagList(canvasId: string, tagList: TagItem[]) {
      this.tagListGroup.push({ id: canvasId, taglist: tagList })
      // this.saveToStorage()
    },
    addTagToCanvas(canvasId: string, tag: TagItem) {
      let group = this.tagListGroup.find(item => item.id === canvasId)
      if (!group) {
        group = { id: canvasId, taglist: [] }
        this.tagListGroup.push(group)
      }
      group.taglist.push(tag)
      // this.saveToStorage()
    },
    updateTag(canvasId: string, unique_id: string, newTag: Partial<TagItem>) {
      const group = this.tagListGroup.find(item => item.id === canvasId)
      if (group) {
        const tag = group.taglist.find(tag => tag.unique_id === unique_id)
        if (tag) {
          Object.assign(tag, newTag)
          // this.saveToStorage()
        }
      }
    },
    removeTag(canvasId: string, unique_id: string) {
      const group = this.tagListGroup.find(item => item.id === canvasId)
      if (group) {
        group.taglist = group.taglist.filter(tag => tag.unique_id !== unique_id)
        // this.saveToStorage()
      }
    },
    clearAllTags() {
      this.tagListGroup = []
      // this.saveToStorage()
    },
    async removeCanvasTagGroup(canvasId: string) {
      this.tagListGroup = this.tagListGroup.filter(group => group.id !== canvasId)
      // this.saveToStorage()
    }
  }
})